import { AES } from "crypto-js";
import CryptoJS from "crypto-js";

// I permessi di parcellazione sono configurabili separatamente, ma i ruoli
// generali equivalenti devono continuare a essere una garanzia minima di
// accesso. In particolare un admin generale non puo' perdere i settori della
// parcellazione e un addetto Paghe deve poter inserire adempimenti Paghe.
const ACCESS_ROLE_FALLBACKS = {
  parc_admin: "admin",
  parc_team_leader: "team_leader",
  parc_paghe: "paghe",
  parc_assunzioni: "assunzioni",
  parc_consulente: "consulente",
  parc_amministrazione: "amministrazione",
};

export const handleCalcolo = (
  prestazione,
  importo_prestazione,
  metodo_fatturazione,
  cedolini_elaborati
) => {
  let importo = 0;

  switch (metodo_fatturazione) {
    case 1: //FORFAIT prezzo diretto. Listino prezzo per clienti
      importo = importo_prestazione;
      break;

    case 3: //LISTINO prezzo diretto. Listino prezzo per clienti
      importo = parseInt(cedolini_elaborati) * importo_prestazione;

      break;
  }

  return importo;
};

export const knowAcces = (options) => {
  //option sarà un array con i dettagli di chi può entrare
  try {
    const stored = localStorage.getItem("cpt_auth");
    if (!stored) return false;

    let auth = AES.decrypt(stored, "FPfT5JvxQ2SN").toString(
      CryptoJS.enc.Utf8
    );

    let res = JSON.parse(auth);

    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const fallback = ACCESS_ROLE_FALLBACKS[option];
      if (Number(res[option]) === 1 || (fallback && Number(res[fallback]) === 1)) {
        return true;
      }
    }
  } catch {
    return false;
  }

  return false;
};
